// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"fc6b2e83","605":"64a19d39","809":"62452d41","981":"a3a0a898"}[chunkId] + ".chunk.js";
};